// extracted by mini-css-extract-plugin
export var image = "gz_dj";